import {
  ADMIN_SETTING_PAGE_ACCOUNTING_MANAGEMENT,
  ADMIN_SETTING_PAGE_CALENDAR_MANAGEMENT,
  ADMIN_SETTING_PAGE_CITY_MANAGEMENT,
  ADMIN_SETTING_PAGE_DOCUMENT_MANAGEMENT,
  ADMIN_SETTING_PAGE_MILESTONE_MANAGEMENT,
  ADMIN_SETTING_PAGE_ORDER_MANAGEMENT,
  ADMIN_SETTING_PAGE_PROFILE_MANAGEMENT,
  ADMIN_SETTING_PAGE_RELATIONSHIP_MANAGEMENT,
  ADMIN_SETTING_PAGE_SYSTEM_ADMINISTRATION,
  ADMIN_SETTING_PAGE_USER_MANAGEMENT,
  ENTITY_NAMES,
  ICONS_WEB,
  NAV_ITEM_GROUPS,
  PERMISSIONS,
} from "@miplatform/constants";

export const adminNavItems = [
  {
    name: "User Management",
    icon: "mdiAccountCogOutline",
    path: "/settings/user-management",
    permissionName: [PERMISSIONS.USER.READ, PERMISSIONS.ROLE.READ],
    testId: "nav-item-user-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  {
    name: "Order Management",
    icon: "mdiClipboardListOutline",
    path: "/settings/order-management",
    permissionName: [PERMISSIONS.ORDER.READ],
    testId: "nav-item-order-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  {
    name: "Accounting Management",
    icon: "mdiCurrencyUsd",
    path: "/settings/accounting-management",
    permissionName: [PERMISSIONS.QUICKBOOKS.GET_CONFIG],
    testId: "nav-item-accounting-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  {
    name: "Calendar Management",
    icon: "mdiCalendarOutline",
    path: "/settings/calendar-management",
    permissionName: [
      PERMISSIONS.CALENDAR_SET.UPDATE,
      PERMISSIONS.CALENDAR.UPDATE,
    ],
    testId: "nav-item-calendar-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  {
    name: "Document Management",
    icon: "mdiFileDocumentOutline",
    path: "/settings/document-management",
    permissionName: [
      PERMISSIONS.DOCUMENT_CATEGORY.CREATE,
      PERMISSIONS.DOCUMENT_CATEGORY.UPDATE,
      PERMISSIONS.DOCUMENT_CATEGORY.DELETE,
    ],
    testId: "nav-item-document-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  // TODO add permissions to below item
  {
    name: "City Management",
    icon: "mdiCityVariantOutline",
    path: "/settings/city-management",
    testId: "nav-item-city-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  // TODO add permissions to below item
  {
    name: "Relationship Management",
    icon: "mdiAccountGroup",
    path: "/settings/relationship-management",
    testId: "nav-item-relationship-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  // TODO add permissions to below item
  {
    name: "Milestone Management",
    icon: "mdiAccountGroup",
    path: "/settings/milestone-management",
    testId: "nav-item-milestone-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  // TODO add permissions to below item
  {
    name: "Profile Management",
    icon: "mdiAccountBox",
    path: "/settings/profile-management",
    testId: "nav-item-profile-management",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  {
    name: "System Administration",
    icon: "mdiShieldAccountVariant",
    path: "/settings/system-administration/tenant-configuration",
    permissionName: [PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION],
    testId: "nav-item-system-administration",
    group: NAV_ITEM_GROUPS.ADMIN,
  },
  {
    name: "MiBuild",
    icon: ICONS_WEB.HOME,
    path: "/",
    testId: "nav-item-go-back-to-mibuild",
    group: NAV_ITEM_GROUPS.SETTINGS,
  },
];

export const adminChildNavItem = {
  [ADMIN_SETTING_PAGE_USER_MANAGEMENT]: [
    {
      name: "Users",
      description: "Manage Users",
      icon: "mdiAccountMultiple",
      path: "/settings/user-management/users",
      permissionName: PERMISSIONS.USER.READ,
    },
    {
      name: "Contacts",
      description: "Manage Contacts",
      icon: "mdiContacts",
      path: "/settings/user-management/contacts",
    },
    {
      name: "Roles",
      description: "Manage roles and permissions",
      icon: "mdiShieldAccountVariant",
      path: "/settings/user-management/roles",
      permissionName: PERMISSIONS.ROLE.READ,
    },
    {
      name: "Titles",
      description: "Manage Titles",
      icon: "mdiBadgeAccountHorizontal",
      path: "/settings/user-management/titles",
      permissionName: PERMISSIONS.TITLE.READ,
    },
    {
      name: "Trades",
      description: "Manage Trades",
      icon: "mdiToolbox",
      path: "/settings/user-management/trades",
      permissionName: PERMISSIONS.TRADE.READ,
    },
  ],
  [ADMIN_SETTING_PAGE_ORDER_MANAGEMENT]: [
    {
      name: `${ENTITY_NAMES.ORDER_TEMPLATES}`,
      description: `Manage ${ENTITY_NAMES.ORDER_TEMPLATES}`,
      icon: "mdiFileEditOutline",
      path: "/settings/order-management/order-types",
      testId: "manage-order-templates",
    },
    {
      name: `${ENTITY_NAMES.ISSUE_TEMPLATES}`,
      description: `Manage ${ENTITY_NAMES.ISSUE_TEMPLATES}`,
      icon: "mdiClipboardOutline",
      path: "/settings/order-management/issue-types",
      permissionName: PERMISSIONS.ORDER.READ,
      testId: "manage-issue-templates",
    },
    {
      name: "Order Reasons",
      description: "Manage Order Reasons",
      icon: "mdiReceiptTextEditOutline",
      path: "/settings/order-management/order-reasons",
      permissionName: PERMISSIONS.ORDER.READ,
      testId: "manage-order-reasons",
    },
    {
      name: `${ENTITY_NAMES.ORDER_TEMPLATE} Capacity`,
      description: `Manage ${ENTITY_NAMES.ORDER_TEMPLATES} Capacity`,
      icon: "mdiPoll",
      path: "/settings/order-management/order-type-capacity",
      permissionName: PERMISSIONS.ORDER.READ,
      testId: "manage-order-template-capacity",
    },
    {
      name: "Assignment Templates",
      description: "Manage Assignment Templates",
      icon: "mdiClipboardOutline",
      path: "/settings/order-management/assignment-templates",
      permissionName: PERMISSIONS.ORDER.READ,
      testId: "manage-assignment-template",
    },
    {
      name: "Order Card Fields",
      description: "Manage Order Card Fields",
      icon: "mdiCardOutline",
      path: "/settings/order-management/order-card-fields",
      permissionName: PERMISSIONS.LABEL_CONFIG.READ,
      testId: "manage-order-card-fields",
    },
    {
      name: `${ENTITY_NAMES.WORK_ORDER_TEMPLATES}`,
      description: `Manage ${ENTITY_NAMES.WORK_ORDER_TEMPLATES}`,
      icon: "mdiClipboardOutline",
      path: "/settings/order-management/work-order-types",
      permissionName: PERMISSIONS.ORDER.READ,
      testId: "manage-work-order-templates",
    },
    {
      name: `${ENTITY_NAMES.INSPECTION_TEMPLATE}`,
      description: `Manage ${ENTITY_NAMES.INSPECTION_TEMPLATES}`,
      icon: "mdiClipboardOutline",
      path: "/settings/order-management/inspection-types",
      permissionName: PERMISSIONS.ORDER.READ,
      testId: "manage-inspection-templates",
    },
  ],
  [ADMIN_SETTING_PAGE_CALENDAR_MANAGEMENT]: [
    {
      name: "Labor Rates",
      description: "Manage Labor Rates",
      icon: "mdiCogOutline",
      path: "/settings/calendar-management/labor-rates",
      permissionName: PERMISSIONS.CALENDAR.UPDATE,
      testId: "manage-labor-rates",
    },
  ],
  [ADMIN_SETTING_PAGE_DOCUMENT_MANAGEMENT]: [
    {
      name: "Document Categories",
      description: "Manage Document Categories",
      icon: "mdiFileDocumentOutline",
      path: "/settings/document-management/document-categories",
      permissionName: [
        PERMISSIONS.DOCUMENT_CATEGORY.CREATE,
        PERMISSIONS.DOCUMENT_CATEGORY.UPDATE,
        PERMISSIONS.DOCUMENT_CATEGORY.DELETE,
      ],
      testId: "manage-document-categories",
    },
  ],
  // TODO: add permissions to below items
  [ADMIN_SETTING_PAGE_CITY_MANAGEMENT]: [
    {
      name: "Cities",
      description: "Manage Cities",
      icon: "mdiCityVariant",
      path: "/settings/city-management/cities",
      testId: "cities",
    },
  ],
  [ADMIN_SETTING_PAGE_ACCOUNTING_MANAGEMENT]: [
    {
      name: "QuickBooks Integration",
      description: "Manage QuickBooks Integration",
      icon: "mdiCurrencyUsd",
      path: "/settings/accounting-management/quickbooks-integration",
      permissionName: [PERMISSIONS.QUICKBOOKS.GET_CONFIG],
      testId: "quickbooks-integration",
    },
    {
      name: "Import QuickBooks Customers",
      description: "Import Customers and Jobs from QuickBooks",
      icon: "mdiAccountMultiplePlus",
      path: "/settings/accounting-management/import-quickbooks-customers",
      permissionName: [PERMISSIONS.QUICKBOOKS.GET_CONFIG],
      testId: "import-quickbooks-customers",
    },
  ],
  // TODO: add permissions to below items
  [ADMIN_SETTING_PAGE_RELATIONSHIP_MANAGEMENT]: [
    {
      name: "Contacts",
      description: "Manage Contact Relationships",
      icon: "mdiContacts",
      path: "/settings/relationship-management/contact-relationships",
      testId: "contact-relationships",
    },
  ],
  [ADMIN_SETTING_PAGE_PROFILE_MANAGEMENT]: [
    {
      name: "My Account",
      description: "Manage My Account",
      icon: "mdiAccountCircle",
      path: "/settings/profile-management/my-account",
      testId: "my-profile-account",
    },
  ],
  [ADMIN_SETTING_PAGE_SYSTEM_ADMINISTRATION]: [
    {
      name: "Tenant Configuration",
      description: "Read and update tenant configuration endpoints",
      icon: "mdiShieldAccountVariant",
      path: "/settings/system-administration/tenant-configuration",
      permissionName: [PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION],
      testId: "tenant-configuration",
    },
  ],
  // TODO: add permissions to below items
  [ADMIN_SETTING_PAGE_MILESTONE_MANAGEMENT]: [
    {
      name: `Manage ${ENTITY_NAMES.BUILD_TEMPLATES}`,
      description: `Manage ${ENTITY_NAMES.BUILD_TEMPLATES}`,
      icon: "mdiCityVariant",
      path: "/settings/milestone-management/build-types",
      testId: "buildTemplates",
    },
    {
      name: "Manage Milestones",
      description: "Manage Milestones",
      icon: "mdiCityVariant",
      path: "/settings/milestone-management/manage-milestones",
      testId: "manageMilestones",
    },
  ],
};
